import type { Faction } from '@bid/shared-types';

export const factions: Faction[] = [
  {
    name: 'The Lampblacks',
    tier: 2,
    hold: 'Weak',
    turf: ["Crow's Foot", 'The Docks'],
    assets: ['Street thugs', 'Gondola network'],
    quirks: ['Brutal enforcers', 'Loyal to a fault'],
    notables: ['Bazso Baz (Leader)', 'Ulf Ironborn (Lieutenant)'],
    allies: ['The Gray Cloaks'],
    enemies: ['The Red Sashes', 'The Billhooks'],
  },
  {
    name: 'The Red Sashes',
    tier: 2,
    hold: 'Strong',
    turf: ["Crow's Foot"],
    assets: ['Sword fighters', 'Drug dens'],
    quirks: ['Drug dealers', 'Protectors of culture'],
    notables: ['Mylera Klev (Leader)', 'Sera (Lieutenant)'],
    allies: ['The Crows'],
    enemies: ['The Lampblacks', 'The Hive'],
  },
  {
    name: 'The Gray Cloaks',
    tier: 2,
    hold: 'Weak',
    turf: ['Charhollow', 'The Docks'],
    assets: ['Informants', 'Disguises'],
    quirks: ['Master spies', 'Double agents'],
    notables: ['Lord Scurlock (Leader)'],
    allies: ['The Lampblacks'],
    enemies: ['The Unseen', 'The Crows'],
  },
  {
    name: 'The Billhooks',
    tier: 2,
    hold: 'Strong',
    turf: ['Charhollow', 'Coalridge'],
    assets: ['Butchers', 'Meat hooks'],
    quirks: ['Terrifying reputation', 'Violent tendencies'],
    notables: ['Tarvul (Leader)', 'Coran (Lieutenant)'],
    allies: [],
    enemies: ['The Lampblacks'],
  },
  {
    name: 'The Hive',
    tier: 4,
    hold: 'Strong',
    turf: ['Six Towers'],
    assets: ['Merchant network', 'Banking services'],
    quirks: ['Business-like', 'Corrupt officials'],
    notables: ['Lord Strangford (Leader)'],
    allies: ['The Ministry of Preservation'],
    enemies: ['The Red Sashes'],
  },
  {
    name: 'The Unseen',
    tier: 4,
    hold: 'Strong',
    turf: ['Six Towers'],
    assets: ['Spies everywhere', 'Secret magic'],
    quirks: ['Invisible leadership', 'Mysterious motives'],
    notables: ['The Wraiths (Rumored leaders)'],
    allies: [],
    enemies: ['The Gray Cloaks'],
  },
];
